import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getOverrides, MuiMarkdown } from 'mui-markdown';
import { Card, CardContent, CardHeader, Grid, IconButton, Typography } from '@mui/material';
import { Edit, HistoryEdu } from '@mui/icons-material';
import { CarModel } from 'models/StockModel';
import useCarModals from 'modules/cars/hooks/useCarModals';
import auth from 'recoil/atoms/auth';


type PhotoCardProps = {
    car: CarModel,
}

const NotesCard = ({car}: PhotoCardProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');
    const {openEditNotesModal, openActivity} = useCarModals();
    const filtered = car.albums.filter(a => a.name.endsWith('note') && a.note);

    const actions = <>
        {my.permissions.has('cars manage') && (
            <IconButton
                aria-label="Show activity"
                onClick={() => openActivity(car.id)}
            >
                <HistoryEdu/>
            </IconButton>
        )}
        {' '}
        {my.permissions.has('cars manage') && (
            <IconButton
                aria-label="Edit notes"
                onClick={() => openEditNotesModal(car)}
            >
                <Edit/>
            </IconButton>
        )}
    </>;

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={t('notes')}
                action={actions}
            />
            <CardContent>
                <Grid container columnSpacing={2}>
                    {car.note && <>
                        <Grid item xs={3}>
                            {t('note')}
                        </Grid>
                        <Grid item xs={9} sx={{whiteSpace: 'pre-wrap'}}>
                            <MuiMarkdown
                                overrides={{
                                    ...getOverrides({}),
                                    p: {
                                        component: Typography,
                                        props: {
                                            sx: {mb: 1},
                                        },
                                    },
                                    em: {
                                        props: {
                                            style: {color: 'red'},
                                        },
                                    },
                                }}
                            >
                                {car.note}
                            </MuiMarkdown>
                        </Grid>
                    </>}

                    {car.yard?.location && <>
                        <Grid item xs={3}>
                            {t('yard_location')}
                        </Grid>
                        <Grid item xs={9}>
                            {car.yard.location}
                        </Grid>
                    </>}

                    {car.yard?.key && <>
                        <Grid item xs={3}>
                            {t('key_number')}
                        </Grid>
                        <Grid item xs={9}>
                            {car.yard.key}
                        </Grid>
                    </>}

                    {filtered.map(a => (
                        <React.Fragment key={a.name}>
                            <Grid item xs={3}>
                                {a.name.replace('_', ' ')}
                            </Grid>
                            <Grid item xs={9}>
                                {a.note}
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default NotesCard;
